import { PreviewEmptyIcon } from "./LatestServicesPreviewIcons";

function LatestServicesEmptyState() {
  return (
    <div className="LatestServicesPreview__empty" dir="rtl">
      <span
        className="LatestServicesPreview__empty-icon"
        aria-hidden
      >
        <PreviewEmptyIcon />
      </span>
      <p className="LatestServicesPreview__empty-text">
        سرویسی برای نمایش وجود ندارد
      </p>
    </div>
  );
}

export default LatestServicesEmptyState;
